import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@design-system/box';
import { Loader } from '@design-system/loader';
import { Skeleton } from '@design-system/skeleton';
import { useEffect, useState } from 'react';
import { styled } from 'styled-components';
import { DEFAULT_ASPECT_RATIO, LOADER_DELAY } from '../constants';
export const Loading = ({ aspectRatio = DEFAULT_ASPECT_RATIO, withDescription = true, }) => {
    const [showLoader, setShowLoader] = useState(false);
    useEffect(() => {
        const timer = setTimeout(setShowLoader, LOADER_DELAY, true);
        return () => clearTimeout(timer);
    }, []);
    return (_jsxs(Wrapper, { "data-testid": "ds-embed-loading", flexDirection: "column", children: [_jsx(Preview, { "$aspectRatio": aspectRatio, children: showLoader && _jsx(Loader, {}) }), withDescription && (_jsxs(Box, { flexDirection: "column", px: 3, py: 4, children: [_jsx(Line, { width: "50%" }), _jsx(Line, { mt: 1, width: "27%" }), _jsx(Line, { mt: 2, width: "100%" })] }))] }));
};
const Wrapper = styled(Box).attrs({
    bg: 'snow',
    flex: 1,
    flexDirection: 'column',
}) ``;
const Line = styled(Skeleton).attrs(({ theme }) => ({
    height: theme.lineHeights[2],
})) ``;
const Preview = styled(Skeleton).attrs({
    height: 'auto',
    width: '100%',
}) `
  aspect-ratio: ${({ $aspectRatio }) => $aspectRatio};
`;
//# sourceMappingURL=Loading.js.map